import { useAccount, useMsal } from "@azure/msal-react";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { getAPI } from "src/utils/fetch";

export interface SearchStatusResponse {
    data_sources: DatasourceIngestionStatus[];
}

export interface DatasourceIngestionStatus {
    id: string;
    total_count: number;
    ingestion_status: string;
    product_lines: ProductLineCount[];
    latest_document_timestamp: number;
    has_access: boolean;
}

export interface ProductLineCount {
    count: number;
    product_line: string;
}
const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
export const useIngestionStatus = (): UseQueryResult<SearchStatusResponse, Error> => {
    const { instance } = useMsal();
    const account = useAccount();
    const isAuthenticated = !!account?.idToken;

    return useQuery<SearchStatusResponse, Error>({
        queryKey: ["datasource_ingestion_status"],
        queryFn: async () => {
            const response = await getAPI({
                url: `${BACKEND_URL}/v1/search/status`,
                instance,
            });
            return await response.json();
        },
        enabled: isAuthenticated,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });
};
